import { IApi } from '../../api'
import { createAction } from '../types'

export const prefix = 'messages'

export const SEND_MESSAGE_REQUEST = `${prefix}/SEND_MESSAGE_REQUEST`
export const SEND_MESSAGE_SUCCESS = `${prefix}/SEND_MESSAGE_SUCCESS`
export const SEND_MESSAGE_FAILURE = `${prefix}/SEND_MESSAGE_FAILURE`

export const sendMessage = createAction(
  (params: { subject: string; message: string; recipientEmail?: string }) => ({
    type: [SEND_MESSAGE_REQUEST, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE],
    promise: (api: IApi) => api.messages.sendMessage(params),
    params,
  }),
)
